import conversionUtcDate from 'src/utils/conversionUtcDate'
import { getLocalAndroidAll } from '/src/@api/dashboard'
import { createDeviceScopedChatSlice } from 'src/store/apps/createDeviceScopedChatSlice'

const readDeviceSnapshot = () => ({
  userData: JSON.parse(localStorage.getItem('userData') || '{}')?.data || { email: '' },
  deviceUser: JSON.parse(localStorage.getItem('DeviceUser') || '{}')
})

const mapDetail = item => ({
  ...item,
  time: conversionUtcDate(item.date, 'UTC', 'YYYY-MM-DD HH:mm'),
  defaultAvata: '/images/avatars/10.png'
})

const loadSummary = async ({ page }) => {
  const { userData, deviceUser } = readDeviceSnapshot()
  const deviceUdid = deviceUser?.username || ''
  const response = await getLocalAndroidAll({
    username: userData.email,
    params: { category: 'SMS_SUMMARY', offset: (page - 1) * 200, limit: 200, deviceUdid }
  })
  const data = response.data.contents?.map(item => ({
    ...item,
    guid: item.chatid,
    time: conversionUtcDate(item.snippetTimestamp, 'UTC', 'YYYY-MM-DD'),
    defaultAvata: '/images/avatars/10.png'
  })) || []
  let defaultSelectData = []
  let rightTotalCount = 0
  if (page === 1 && data[0]) {
    const detail = await getLocalAndroidAll({
      username: userData.email,
      params: { category: 'SMS_DETAIL', offset: 0, limit: 50, deviceUdid, rid: data[0].chatid }
    })
    defaultSelectData = detail.data.contents?.map(mapDetail) || []
    rightTotalCount = detail.data.totalCount
  }

  return {
    data,
    defaultSelectData,
    leftTotalCount: response.data.totalCount,
    ...(page === 1 ? { rightTotalCount } : {})
  }
}

const loadDetail = async ({ contact, page }) => {
  const { userData, deviceUser } = readDeviceSnapshot()
  const response = await getLocalAndroidAll({
    username: userData.email,
    params: {
      category: 'SMS_DETAIL',
      offset: (page - 1) * 50,
      limit: 50,
      rid: contact.guid,
      deviceUdid: deviceUser?.username || ''
    }
  })

  return {
    selected: response.data.contents?.map(item => ({ ...mapDetail(item), defaultAvata: '/images/avatars/11.png' })) || [],
    rightTotalCount: response.data.totalCount
  }
}

const chat = createDeviceScopedChatSlice({
  sliceName: 'AndroidLocalTextMessages',
  storeKey: 'androidLocalTextMessages',
  actionPrefix: 'androidLocalTextMessages',
  contactKey: 'chatid',
  storageKey: 'smsItem',
  loadSummary,
  loadDetail,
  createExtraState: () => ({ fetchLoading: false })
})

export const fetchUserProfile = chat.fetchSummary
export const selectMessage = chat.selectDetail
export const removeSelectedChat = chat.removeSelectedChat
export default chat.reducer
